import Actions from 'reducers/Setting'
import LanguageService from 'services/LanguageService'
import type { AppDispatch } from 'types/store'

export const getLanguageOptions = () => (dispatch: AppDispatch) => {
  LanguageService.getLanguages()
    .then((langs: any) => {
      dispatch(Actions.loadLangOptions(langs))
    })
    .catch((error: any) => console.warn(error))
}

export default { getLanguageOptions }
